// extracted by mini-css-extract-plugin
export var actions = "_40-0";
export var actionsContainer = "_40-6";
export var border = "_40-1";
export var childFullHeight = "_40-d";
export var collapse = "_40-2";
export var content = "_40-8";
export var contentChild = "_40-c";
export var fullscreen = "_40-a";
export var headerContainer = "_40-3";
export var headerRow = "_40-5";
export var hidePadding = "_40-9";
export var noScrollX = "_40-e";
export var noScrollY = "_40-f";
export var optOutTopPadding = "_40-b";
export var pagePadding = "_40-7";
export var profile = "_40-g";
export var profileContainer = "_40-h";
export var profileImage = "_40-i";
export var profileMain = "_40-j";
export var profileSubtitle = "_40-l";
export var profileTitle = "_40-k";
export var tabsWrapper = "_40-4";
export var title = "_40-m";